export default __webpack_public_path__ + "static/about-b79534e9562046e39caed9cd4638f6ab.png";